import { render, staticRenderFns } from "./ModalDetailsRefuseInsurance.vue?vue&type=template&id=377c3f8a"
import script from "./ModalDetailsRefuseInsurance.vue?vue&type=script&lang=js"
export * from "./ModalDetailsRefuseInsurance.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailsRefuseInsurance.vue?vue&type=style&index=0&id=377c3f8a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports